// Paalm · Tuile produit des grilles : ajout au panier sans quitter la page (18/10/2026).
// Écoute en phase de capture pour que les clics sur le bouton et sur le choix de teinte
// n'ouvrent pas la fiche (product-card.js ouvre la fiche au clic sur la carte).
import { CartUpdatedEvent } from '@theme/events';

if (!window.paalmTuile) {
  window.paalmTuile = true;

  // « Me prévenir » des produits bientôt disponibles : inscription Shopify avec l'étiquette « Lipsticks ».
  const fermerAlertes = (sauf) => {
    document.querySelectorAll('.pt-alerte:not([hidden])').forEach((f) => {
      if (f === sauf) return;
      f.hidden = true;
      f.closest('.pt')?.querySelector('[data-pt-bientot]')?.setAttribute('aria-expanded', 'false');
    });
  };
  const inscrire = async (f) => {
    const champ = f.querySelector('input[type=email]');
    const msg = f.querySelector('.pt-alerte-msg');
    const email = (champ.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      msg.textContent = 'Vérifie ton adresse email.'; msg.hidden = false; champ.focus(); return;
    }
    const ok = f.querySelector('[data-pt-alerte-ok]');
    ok.disabled = true;
    try {
      const r = await fetch(f.action.split('#')[0], { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } });
      // Vérification anti-robot de Shopify : on envoie le formulaire normalement (la cliente revient ensuite sur la page).
      if (/challenge/.test(r.url)) { f.submit(); return; }
      if (!r.ok) throw new Error();
      f.querySelector('.pt-alerte-l').hidden = true;
      msg.textContent = 'C\'est noté, on te prévient dès la sortie.'; msg.hidden = false;
      const b = f.closest('.pt')?.querySelector('[data-pt-bientot]');
      if (b) { b.classList.add('is-ok'); setTimeout(() => { f.hidden = true; b.setAttribute('aria-expanded', 'false'); }, 2200); }
    } catch (err) {
      msg.textContent = 'Oups, réessaie dans un instant.'; msg.hidden = false;
    } finally {
      ok.disabled = false;
    }
  };
  document.addEventListener('submit', (e) => {
    const f = e.target instanceof Element ? e.target.closest('[data-pt-alerte]') : null;
    if (!f) return;
    // On garde la main : sans ça, le script anti-robots de Shopify renvoie le formulaire et quitte la page.
    e.preventDefault();
    e.stopImmediatePropagation();
    inscrire(f);
  }, true);

  const fermerTout = (sauf) => {
    fermerAlertes(sauf);
    document.querySelectorAll('.pt-teintes:not([hidden])').forEach((p) => {
      if (p === sauf) return;
      p.hidden = true;
      const b = p.closest('.pt')?.querySelector('[data-pt-teinte]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  };

  const ajouter = async (btn, variante) => {
    btn.classList.add('is-charge');
    const tiroir = document.querySelector('cart-drawer');
    const sections = tiroir && tiroir.dataset.sectionId ? tiroir.dataset.sectionId : '';
    try {
      const r = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }], sections }),
      });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'Ajout impossible');
      let n;
      try {
        n = (await (await fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })).json()).item_count;
      } catch (e) {}
      // Met à jour le panier latéral et l'ouvre (comportement par défaut de l'icône panier).
      document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: n, source: 'paalm-tuile', variantId: String(variante), sections: data.sections }));
      btn.classList.add('is-ok');
      setTimeout(() => btn.classList.remove('is-ok'), 1800);
    } catch (err) {
      const l = btn.querySelector('.pt-a');
      if (l) {
        const avant = l.textContent;
        l.textContent = 'Réessaie';
        setTimeout(() => { l.textContent = avant; }, 2200);
      }
    } finally {
      btn.classList.remove('is-charge');
    }
  };

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const okAlerte = t.closest('[data-pt-alerte-ok]');
    if (okAlerte && !t.closest('.pt')) {
      e.preventDefault();
      e.stopPropagation();
      inscrire(okAlerte.closest('[data-pt-alerte]'));
      return;
    }
    const tuile = t.closest('.pt');
    if (!tuile) { fermerTout(); return; }

    const alerte = tuile.querySelector('.pt-alerte');
    const bientot = t.closest('[data-pt-bientot]');
    const dansAlerte = t.closest('.pt-alerte');
    if (bientot || dansAlerte) {
      e.stopPropagation();
      if (bientot && alerte) {
        e.preventDefault();
        const ouvrir = alerte.hidden;
        fermerTout(alerte);
        alerte.hidden = !ouvrir;
        bientot.setAttribute('aria-expanded', String(ouvrir));
        if (ouvrir) alerte.querySelector('input[type=email]')?.focus({ preventScroll: true });
      } else if (dansAlerte && t.closest('[data-pt-ferme]')) {
        e.preventDefault();
        alerte.hidden = true;
        tuile.querySelector('[data-pt-bientot]')?.setAttribute('aria-expanded', 'false');
      } else if (dansAlerte && t.closest('[data-pt-alerte-ok]')) {
        e.preventDefault();
        inscrire(alerte);
      }
      return;
    }

    const panneau = tuile.querySelector('.pt-teintes');
    const cta = t.closest('[data-pt-ajout]');
    const teinte = t.closest('[data-pt-v]');
    const ferme = t.closest('[data-pt-ferme]');
    const dansPanneau = t.closest('.pt-teintes');

    if (!cta && !dansPanneau) { fermerTout(); return; }
    e.preventDefault();
    e.stopPropagation();

    if (ferme && panneau) {
      panneau.hidden = true;
      tuile.querySelector('[data-pt-teinte]')?.setAttribute('aria-expanded', 'false');
      return;
    }
    if (teinte && panneau) {
      panneau.hidden = true;
      const b = tuile.querySelector('[data-pt-ajout]');
      b.setAttribute('aria-expanded', 'false');
      ajouter(b, teinte.dataset.ptV);
      return;
    }
    if (cta) {
      if (cta.hasAttribute('data-pt-teinte') && panneau) {
        const ouvrir = panneau.hidden;
        fermerTout(panneau);
        panneau.hidden = !ouvrir;
        cta.setAttribute('aria-expanded', String(ouvrir));
        if (ouvrir) panneau.querySelector('[data-pt-v]')?.focus({ preventScroll: true });
        return;
      }
      ajouter(cta, cta.dataset.v);
    }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') fermerTout();
  });
}
